/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A19Inputs */

const et_faq_a19 = /** @type {(inputs: Faq_A19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodulehe konversioonimäära saab kiirelt tõsta viie muudatusega: selgem pealkiri, mis ütleb täpselt, mida pakud; tugevam CTA-nupp; nähtavam sotsiaalne tõestus; lihtsam kontaktivorm; ja kiirem laadimisaeg. Need muudatused ei nõua täielikku ümberdisaini, kuid võivad konversiooni mitmekordistada. ScalingWebs hindab esmalt, milline muudatus toob suurima tulemuse, ja rakendab selle esimese 30 päeva jooksul.`)
};

const en_faq_a19 = /** @type {(inputs: Faq_A19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can quickly improve website conversion rate with five changes: a clearer headline that states exactly what you offer; a stronger CTA button; more visible social proof; a simpler contact form; and faster loading speed. These don't require a full redesign but can multiply conversions. ScalingWebs first assesses which change will have the greatest impact, then implements it within the first 30 days.`)
};

/**
* | output |
* | --- |
* | "You can quickly improve website conversion rate with five changes: a clearer headline that states exactly what you offer; a stronger CTA button; more visible..." |
*
* @param {Faq_A19Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a19 = /** @type {((inputs?: Faq_A19Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A19Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a19(inputs)
	return en_faq_a19(inputs)
});